import WorkerOnboardingWorkspace from '../components/onboarding/WorkerOnboardingWorkspace';
import React, { useMemo, useState, useEffect } from "react";
import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { ref, uploadBytes } from "firebase/storage";
import { signOut } from "firebase/auth";
import { auth, db, storage } from "../firebase";
import { hasApprovedWorkerReadiness } from "../core/workforce/workerReadiness";
import getDocumentStatusMeta from "../utils/workers/getDocumentStatusMeta";
import { REQUIRED_DOCUMENTS } from "../modules/talentPipeline";
import {
  formatDocumentLabel,
} from "../modules/compliance";




export default function WorkerOnboarding({ user, userProfile, profile }) {
  const workerProfile = userProfile || profile || {};
  const onboardingStatus = String(workerProfile?.onboardingStatus || "").toLowerCase();
  const activeUser = user || auth.currentUser;
const registrationApproved =
  workerProfile?.registrationStatus === "approved" ||
  workerProfile?.canAccessOnboarding === true;

console.log("WORKER ONBOARDING GATE", {
  email: workerProfile?.email,
  registrationStatus: workerProfile?.registrationStatus,
  registrationApproved: workerProfile?.registrationApproved,
  canAccessOnboarding: workerProfile?.canAccessOnboarding,
  onboardingStatus: workerProfile?.onboardingStatus,
  workerStatus: workerProfile?.workerStatus,
  status: workerProfile?.status,
  gateOpen: registrationApproved,
});
  workerProfile?.registrationStatus === "approved" ||
  workerProfile?.canAccessOnboarding === true;

if (!registrationApproved) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#f8fafc",
        padding: 20,
      }}
    >
      <div
        style={{
          maxWidth: 520,
          width: "100%",
          background: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: 16,
          padding: 20,
        }}
      >
        <h2>Registration Received</h2>

        <p>
          Your registration has been received and is awaiting admin approval.
        </p>

        <p style={{ color: "#64748b" }}>
          You will gain access to onboarding once registration is approved.
        </p>

        <button
          onClick={() => auth.signOut()}
          style={{
            marginTop: 12,
            width: "100%",
            height: 40,
            borderRadius: 10,
            border: "1px solid #d8e1ea",
            background: "#fff",
            fontWeight: 900,
            cursor: "pointer",
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
}

  const [uploadedDocs, setUploadedDocs] = useState({});
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [submittedManually, setSubmittedManually] = useState(false);
  const [profileSavedLocally, setProfileSavedLocally] = useState(false);

  const [profileForm, setProfileForm] = useState({
  firstName: workerProfile?.firstName || "",
  lastName: workerProfile?.lastName || "",
  phone: workerProfile?.phone || "",
  homeZip: workerProfile?.homeZip || "",
  city: workerProfile?.city || "",
  state: workerProfile?.state || "",
  primaryRole: workerProfile?.primaryRole || "LVN",
  yearsExperience: workerProfile?.yearsExperience || "",
  travelRadiusMiles: workerProfile?.travelRadiusMiles || 25,
  hasTransportation: workerProfile?.hasTransportation ?? true,
  preferredDays: workerProfile?.preferredDays || [],

availableDays: workerProfile?.availableDays ?? true,
availableEvenings: workerProfile?.availableEvenings ?? false,
availableNights: workerProfile?.availableNights ?? false,
availableWeekends: workerProfile?.availableWeekends ?? true,
});

useEffect(() => {
  if (!userProfile) return;

  setProfileForm((prev) => ({
    ...prev,

    firstName:
      prev.firstName ||
      userProfile.firstName ||
      userProfile.name?.split(" ")?.[0] ||
      "",

    lastName:
      prev.lastName ||
      userProfile.lastName ||
      userProfile.name?.split(" ")?.slice(1).join(" ") ||
      "",

    phone:
      prev.phone ||
      userProfile.phone ||
      "",

    homeZip:
      prev.homeZip ||
      userProfile.homeZip ||
      userProfile.zipCode ||
      userProfile.zip ||
      "",

    city:
      prev.city ||
      userProfile.city ||
      "",

    state:
      prev.state ||
      userProfile.state ||
      "",

    yearsExperience:
      prev.yearsExperience ||
      userProfile.yearsExperience ||
      "",

    primaryRole:
      prev.primaryRole ||
      userProfile.primaryRole ||
      userProfile.position ||
      userProfile.workerType ||
      userProfile.roleType ||
      "",

    travelRadiusMiles:
      prev.travelRadiusMiles ||
      userProfile.travelRadiusMiles ||
      25,

    hasTransportation:
      prev.hasTransportation ??
      userProfile.hasTransportation ??
      false,
  }));
}, [userProfile]);


  // A correction returned during this session must unlock the submitted form
  // and show the server's decision rather than an older local upload snapshot.
  useEffect(() => {
    if (onboardingStatus === "action_required") {
      setSubmittedManually(false);
      setUploadedDocs({});
    }
  }, [onboardingStatus, workerProfile?.credentialMap]);

  const credentialValues = Object.values({ ...workerProfile?.credentialMap, ...uploadedDocs });

  const hasPendingReview = credentialValues.some(
    (cred) => cred?.status === "pending_review"
  );

  const hasReuploadRequired = credentialValues.some(
    (cred) => cred?.status === "reupload_required" || cred?.status === "rejected"
  );

  const hasMissingDocs = REQUIRED_DOCUMENTS.some((docItem) => {
    const item =
      uploadedDocs?.[docItem.key] ||
      workerProfile?.credentialMap?.[docItem.key];

    return !item?.fileName && !item?.fileUrl;
  });

  const workerApproved = hasApprovedWorkerReadiness(workerProfile);

  const workerOperationalStatus = workerApproved
    ? "READY"
    : hasReuploadRequired
      ? "ACTION REQUIRED"
      : hasPendingReview
        ? "UNDER REVIEW"
        : hasMissingDocs
          ? "MISSING DOCUMENTS"
          : "READY FOR REVIEW";

  const completedCount = useMemo(() => {
    return REQUIRED_DOCUMENTS.filter((docItem) => {
      const item =
        uploadedDocs?.[docItem.key] ||
        workerProfile?.credentialMap?.[docItem.key];

      return Boolean(item?.fileUrl);
    }).length;
  }, [uploadedDocs, workerProfile]);

  const isReady = completedCount === REQUIRED_DOCUMENTS.length && !hasReuploadRequired;
const profileComplete =
  profileSavedLocally ||
  workerProfile?.profileComplete === true;

console.log("profileComplete =", profileComplete);
console.log("profileSavedLocally =", profileSavedLocally);

  async function handleSaveProfile() {
  if (!activeUser?.uid) {
    setError("No logged-in worker found.");
    return;
  }

  if (
    !profileForm.firstName.trim() ||
    !profileForm.lastName.trim() ||
    !profileForm.phone.trim() ||
    !profileForm.homeZip.trim() ||
    !profileForm.city.trim() ||
    !profileForm.state.trim() ||
    !profileForm.primaryRole
  ) {
    setError("Please complete all worker profile fields.");
    return;
  }

  setSaving(true);
  setError("");
  setSuccess("");

try {
await updateDoc(doc(db, "users", activeUser.uid), {
  ...profileForm,

  yearsExperience: Number(profileForm.yearsExperience || 0),
  travelRadiusMiles: Number(profileForm.travelRadiusMiles || 25),

  availableDays: !!profileForm.availableDays,
  availableEvenings: !!profileForm.availableEvenings,
  availableNights: !!profileForm.availableNights,
  availableWeekends: !!profileForm.availableWeekends,

  preferredDays: profileForm.preferredDays || [],

profileComplete: true,
profileCompletedAt: serverTimestamp(),

onboardingStatus: "missing_docs",
workerStatus: "onboarding",
workerOperationalState: "ONBOARDING",
status: "onboarding",

updatedAt: serverTimestamp(),
});

setProfileSavedLocally(true);
console.log("Profile saved locally");

setSuccess("Worker profile saved. Continue to document upload.");
  } catch (err) {
    console.error("Save profile failed:", err);
    setError(err?.message || "Failed to save worker profile.");
  } finally {
    setSaving(false);
  }
}

  async function handleFileUpload(docKey, file) {
    try {
      if (!file) return;

      if (!activeUser?.uid) {
  throw new Error("No logged-in worker found.");
}

if (
  workerProfile?.registrationStatus !== "approved" &&
  workerProfile?.canAccessOnboarding !== true
) {
  throw new Error("Registration must be approved before uploading documents.");
}

setError("");
setSuccess("");

      const label = formatDocumentLabel(docKey);
      const uploadedAt = new Date().toISOString();

      const uploadingDoc = {
        key: docKey,
        label,
        status: "uploading",
        verified: false,
        fileName: file.name,
        fileType: file.type,
        fileSize: file.size,
        uploadedAt,
      };

      setUploadedDocs((prev) => ({
        ...prev,
        [docKey]: uploadingDoc,
      }));

      const safeFileName = file.name.replace(/[^\w.\-]+/g, "_");

      const storageRef = ref(
        storage,
        `workerDocuments/${activeUser.uid}/${docKey}-${Date.now()}-${safeFileName}`
      );

      const uploadResult = await uploadBytes(storageRef, file, {
        contentType: file.type,
        contentDisposition: 'inline',
        cacheControl: 'private, no-store',
        customMetadata: { workerUid: activeUser.uid, documentKey: docKey },
      });

      const documentReference = `gs://${storageRef.bucket}/${storageRef.fullPath}`;

      const uploadedDoc = {
        key: docKey,
        label,
        status: "pending_review",
        verified: false,
        fileName: file.name,
        fileType: file.type,
        fileSize: file.size,
        fileUrl: documentReference,
        storagePath: storageRef.fullPath,
        storageGeneration: String(uploadResult.metadata?.generation || ''),
        uploadedAt: new Date().toISOString(),
        reviewedAt: null,
        reviewedBy: "",
        reviewedByUid: "",
        rejectionReason: "",
      };

      const nextCredentialMap = {
        ...(workerProfile?.credentialMap || {}),
        ...(uploadedDocs || {}),
        [docKey]: uploadedDoc,
      };

      await updateDoc(doc(db, "users", activeUser.uid), {
        [`credentialMap.${docKey}`]: uploadedDoc,

        onboardingCompleted: false,
        onboardingStatus: "in_progress",
        status: "onboarding",
        complianceStatus: "collecting_documents",
        workerOperationalState: "ONBOARDING",
        workerStatus: "onboarding",

        updatedAt: serverTimestamp(),
      });

      setUploadedDocs(nextCredentialMap);
      setSuccess(`${uploadedDoc.label} uploaded.`);
    } catch (err) {
      console.error("Document upload failed:", err);

      setUploadedDocs((prev) => ({
        ...prev,
        [docKey]: {
          ...(prev?.[docKey] || {}),
          key: docKey,
          label: formatDocumentLabel(docKey),
          status: "failed",
          error: "Upload could not be completed. Please try again or contact your administrator.",
        },
      }));

      setError("Upload could not be completed. Please try again or contact your administrator.");
    }
    
  }
  
  async function handleSubmitOnboarding() {
    try {
      setSaving(true);
      setError("");
      setSuccess("");

    if (!activeUser?.uid) {
  throw new Error("No logged-in worker found.");
}


if (
  workerProfile?.registrationStatus !== "approved" &&
  workerProfile?.canAccessOnboarding !== true
) {
  throw new Error("Registration must be approved before uploading documents.");
}

setError("");
setSuccess("");

      if (hasReuploadRequired) {
        throw new Error("Replace the documents marked for reupload before submitting.");
      }

      const credentialMap = Object.fromEntries(
        REQUIRED_DOCUMENTS.map((docItem) => {
          const item =
            uploadedDocs?.[docItem.key] ||
            workerProfile?.credentialMap?.[docItem.key] ||
            workerProfile?.documents?.[docItem.key] ||
            workerProfile?.uploadedDocs?.[docItem.key] ||
            {};

          const hasFile =
            !!item?.fileUrl ||
            !!item?.downloadURL ||
            !!item?.url;

          return [
            docItem.key,
            {
              key: docItem.key,
              label: docItem.label,
              fileName: item?.fileName || item?.name || "",
              fileUrl: item?.fileUrl || item?.downloadURL || item?.url || "",
              fileType: item?.fileType || item?.type || "",
              fileSize: item?.fileSize || item?.size || 0,
              storagePath: item?.storagePath || '',
              storageGeneration: item?.storageGeneration || '',
              status: hasFile ? "pending_review" : "missing",
              verified: false,
              uploadedAt:
                item?.uploadedAt ||
                item?.createdAt ||
                (hasFile ? new Date().toISOString() : ""),
              reviewedAt: null,
              reviewedBy: "",
              reviewedByUid: "",
              rejectionReason: "",
            },
          ];
        })
      );

      const allDocsHaveFiles = REQUIRED_DOCUMENTS.every((docItem) => {
        const item = credentialMap?.[docItem.key] || {};
        return (
          !!item?.fileUrl ||
          !!item?.downloadURL ||
          !!item?.url
        );
      });

      if (!allDocsHaveFiles) {
        throw new Error("Upload all required documents before submitting.");
      }

      await updateDoc(doc(db, "users", activeUser.uid), {
        onboardingStatus: "submitted",
        onboardingCompleted: false,
        status: "under_review",
        complianceStatus: "under_review",
        workerOperationalState: "UNDER_REVIEW",
        workerStatus: "under_review",

        // Uploads already persist each document separately. Submitting must not
        // overwrite a concurrent review or reset approvals on unchanged files.

        submittedAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });

      setUploadedDocs(credentialMap);
      setSuccess("Documents submitted. Admin review is pending.");
      setSubmittedManually(true);

      if (typeof setOnboardingStatus === "function") {
        setOnboardingStatus("submitted");
      }
    } catch (err) {
      console.error("Submit onboarding error:", err);
      setError(err?.message || "Failed to submit onboarding.");
    } finally {
      setSaving(false);
    }
  }

  async function handleLogout() {
    await signOut(auth);
  }

  function getHeaderBadge() {
    if (workerApproved) {
      return {
        text: "APPROVED",
        background: "#052e16",
        color: "#86efac",
        border: "1px solid #166534",
      };
    }

    if (workerOperationalStatus === "UNDER REVIEW") {
      return {
        text: "UNDER REVIEW",
        background: "#451a03",
        color: "#fdba74",
        border: "1px solid #ea580c",
      };
    }

    if (workerOperationalStatus === "ACTION REQUIRED") {
      return {
        text: "ACTION REQUIRED",
        background: "#450a0a",
        color: "#fecaca",
        border: "1px solid #dc2626",
      };
    }

    if (workerOperationalStatus === "READY FOR REVIEW") {
      return {
        text: "READY FOR REVIEW",
        background: "#082f49",
        color: "#7dd3fc",
        border: "1px solid #0284c7",
      };
    }

    return {
      text: isReady ? "READY TO SUBMIT" : "MISSING DOCUMENTS",
      background: isReady ? "#052e16" : "#451a03",
      color: isReady ? "#86efac" : "#fdba74",
      border: isReady ? "1px solid #166534" : "1px solid #ea580c",
    };
  }
const badge = getHeaderBadge();

const reviewLocked = !hasReuploadRequired && (
  submittedManually ||
  ["submitted", "pending_review"].includes(onboardingStatus) ||
  ["under_review", "pending_review"].includes(
    String(workerProfile?.complianceStatus || "").toLowerCase()
  ) ||
  String(workerProfile?.workerStatus || "").toLowerCase() === "under_review");

if (reviewLocked) {
  return <WorkerOnboardingWorkspace identity={workerProfile?.displayName || activeUser?.email} status="Pending review" reviewLocked exit={<button type="button" onClick={handleLogout}>Sign out</button>}><h2>Documents submitted</h2><p>Your documents have been submitted and are awaiting admin review.</p></WorkerOnboardingWorkspace>;
}

return <WorkerOnboardingWorkspace identity={workerProfile?.displayName || workerProfile?.email || activeUser?.email || 'Worker Account'} status={badge.text} profileComplete={profileComplete} approved={workerApproved} error={error} success={success} exit={<button type="button" onClick={handleLogout}>Sign out</button>}><div
        style={{
          background: "#ffffff",
          border: "1px solid #e2e8f0",
          borderRadius: 20,
          padding: 14,
          boxShadow: "0 12px 30px rgba(15,23,42,.06)",
        }}
      >
        {!profileComplete ? (
          <div style={{ display: "grid", gap: 10 }}>


            {[
              ["firstName", "First Name"],
              ["lastName", "Last Name"],
              ["phone", "Phone"],
              ["homeZip", "ZIP Code"],
              ["city", "City"],
              ["state", "State"],
              ["yearsExperience", "Years Experience"],
              ["travelRadiusMiles", "Travel Radius Miles"],
            ].map(([key, label]) => (
              <input
                key={key}
                placeholder={label}
                value={profileForm[key]}
                onChange={(e) =>
                  setProfileForm((prev) => ({
                    ...prev,
                    [key]: e.target.value,
                  }))
                }
                style={{
                  border: "1px solid #cbd5e1",
                  borderRadius: 10,
                  padding: "10px 12px",
                  fontWeight: 800,
                }}
              />
            ))}

            <select
              value={profileForm.primaryRole}
              onChange={(e) =>
                setProfileForm((prev) => ({
                  ...prev,
                  primaryRole: e.target.value,
                }))
              }
              style={{
                border: "1px solid #cbd5e1",
                borderRadius: 10,
                padding: "10px 12px",
                fontWeight: 800,
              }}
            >
              <option value="CNA">CNA</option>
              <option value="LVN">LVN</option>
              <option value="RN">RN</option>
              <option value="MED_AIDE">Med Aide</option>
              <option value="CAREGIVER">Caregiver</option>
            </select>

            <label style={{ fontWeight: 800 }}>
              <input
                type="checkbox"
                checked={profileForm.hasTransportation}
                onChange={(e) =>
                  setProfileForm((prev) => ({
                    ...prev,
                    hasTransportation: e.target.checked,
                  }))
                }
              />{" "}
              Reliable Transportation
            </label>

            <div style={{ fontWeight: 950, marginTop: 8 }}>
  Availability
</div>

{[
  ["availableDays", "Days"],
  ["availableEvenings", "Evenings"],
  ["availableNights", "Nights"],
  ["availableWeekends", "Weekends"],
].map(([key, label]) => (
  <label key={key} style={{ fontWeight: 800 }}>
    <input
      type="checkbox"
      checked={!!profileForm[key]}
      onChange={(e) =>
        setProfileForm((prev) => ({
          ...prev,
          [key]: e.target.checked,
        }))
      }
    />{" "}
    {label}
  </label>
))}

<div style={{ fontWeight: 950, marginTop: 12 }}>
  Preferred Work Days
</div>

{[
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
].map((day) => (
  <label key={day} style={{ fontWeight: 800 }}>
    <input
      type="checkbox"
      checked={(profileForm.preferredDays || []).includes(day)}
      onChange={(e) => {
        const current = profileForm.preferredDays || [];

        setProfileForm((prev) => ({
          ...prev,
          preferredDays: e.target.checked
            ? [...current, day]
            : current.filter((d) => d !== day),
        }));
      }}
    />{" "}
    {day}
  </label>
))}

            <button
              type="button"
              onClick={handleSaveProfile}
              disabled={saving}
              style={{
                padding: "12px 14px",
                borderRadius: 12,
                border: "1px solid #2563eb",
                background: "#2563eb",
                color: "#fff",
                fontWeight: 950,
                cursor: saving ? "not-allowed" : "pointer",
                opacity: saving ? 0.65 : 1,
              }}
            >
              Save Profile & Continue
            </button>
          </div>
            ) : (
          <>
            <div style={{ fontWeight: 950, fontSize: 17, color: "#0f172a" }}>
              Required Documents
            </div>

            <div
              style={{
                marginTop: 4,
                fontSize: 12,
                fontWeight: 800,
                color: "#64748b",
              }}
            >
              {completedCount} of {REQUIRED_DOCUMENTS.length} submitted
            </div>

            <div style={{ display: "grid", gap: 10, marginTop: 14 }}>
              {REQUIRED_DOCUMENTS.map((docItem) => {
                const uploaded =
                  uploadedDocs?.[docItem.key] ||
                  workerProfile?.credentialMap?.[docItem.key] ||
                  {};

                const hasFile = uploaded?.fileName || uploaded?.fileUrl;
                const credentialStatus = uploaded?.status || "missing";
                const docMeta = getDocumentStatusMeta(credentialStatus);

                return (
                  <div
                    key={docItem.key}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr auto",
                      gap: 10,
                      alignItems: "center",
                      borderRadius: 16,
                      border: hasFile ? "1px solid #bbf7d0" : "1px solid #fecaca",
                      background: hasFile ? "#ecfdf5" : "#fff5f5",
                      padding: "12px 12px",
                    }}
                  >
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 900, color: "#0f172a" }}>
                        {docItem.label}
                      </div>

                      {uploaded?.rejectionReason && (
                        <p role="alert" style={{ color: "#b91c1c", margin: "6px 0" }}>
                          Correction needed: {uploaded.rejectionReason}
                        </p>
                      )}

                      <div
                        style={{
                          marginTop: 3,
                          fontSize: 11,
                          fontWeight: 800,
                          color: hasFile ? "#166534" : "#dc2626",
                        }}
                      >
                        {hasFile
                          ? `${credentialStatus === "uploading" ? "Uploading" : "Selected"}: ${
                              uploaded?.fileName || uploaded?.name || "Document"
                            }`
                          : "No file chosen — required before worker is ready"}
                      </div>
                    </div>

                    <div style={{ display: "grid", gap: 6, justifyItems: "end" }}>
                      <input
                        type="file"
                        aria-label={`Upload ${docItem.label}`}
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={(e) => {
                          const file = e.target.files?.[0];
                          if (!file) return;
                          e.target.value = "";
                          handleFileUpload(docItem.key, file);
                        }}
                      />

                      <span
                        style={{
                          padding: "6px 12px",
                          borderRadius: 999,
                          fontSize: 11,
                          fontWeight: 900,
                          background: docMeta.bg,
                          border: `1px solid ${docMeta.border}`,
                          color: docMeta.text,
                        }}
                      >
                        {docMeta.label}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>

            {submittedManually ||
            String(workerProfile?.onboardingStatus || "").toLowerCase() ===
              "submitted" ? (
              <button
                type="button"
                disabled
                style={{
                  width: "100%",
                  marginTop: 14,
                  padding: "14px 18px",
                  borderRadius: 14,
                  border: "1px solid #93c5fd",
                  background: "#dbeafe",
                  color: "#1e40af",
                  fontWeight: 950,
                  cursor: "not-allowed",
                  opacity: 0.75,
                }}
              >
                Submitted — Awaiting Admin Review
              </button>
            ) : (
              <button
                type="button"
                onClick={handleSubmitOnboarding}
                disabled={saving || !isReady}
                style={{
                  width: "100%",
                  marginTop: 14,
                  padding: "14px 18px",
                  borderRadius: 14,
                  border: "1px solid #15803d",
                  background: saving || !isReady ? "#94a3b8" : "#15803d",
                  color: "#ffffff",
                  fontWeight: 950,
                  cursor: saving || !isReady ? "not-allowed" : "pointer",
                  opacity: saving || !isReady ? 0.65 : 1,
                }}
              >
                {saving
                  ? "Submitting..."
                  : isReady
                  ? "Submit Documents for Admin Review"
                  : "Upload All Required Documents"}
              </button>
            )}
          </>
        )}

        <button
          type="button"
          onClick={handleLogout}
          style={{
            marginTop: 10,
            width: "100%",
            height: 40,
            borderRadius: 14,
            border: "1px solid #e2e8f0",
            background: "#ffffff",
            color: "#0f172a",
            fontWeight: 900,
            cursor: "pointer",
          }}
        >
          Logout
        </button>
      </div></WorkerOnboardingWorkspace>;
}
